/**
 * @file URL 处理
 * @author dafo<huanghoujin@baijiahulian.com>
 */

/**
 * 提取url后面的参数 返回一个对象
 *
 * @param {URL | string} url URL 地址
 * @return {Object} url 中的包含的 query 对象化
 */
export const parseUrl = url => {
    const query = {};
    const paraArray = url.substring(url.indexOf('?') + 1).split('&');
    for (let i = 0, len = paraArray.length; i < len; i++) {
        const [key, value] = paraArray[i].split('=');
        query[key] = value;
    }
    return query;
};

/**
 *  获取 originPath
 *
 * @return {string} 获取到的 originPath
 */
export const getOriginPath = () => {
    const {origin, pathname} = location;

    return origin + pathname;
};

/**
 *  获取当前环境
 *
 * {string} 开发环境
 */
export const getCurrentEnv = () => {
    let env;
    env = location.host.split('.')[0].split('-')[0];
    if (env.indexOf(':') > -1 || env.indexOf('127') > -1) {
        env = 'develop';
    }
    return env;
};

/**
 * 拼接path
 *
 * @param {string} path 上级path
 * @param {string} subPath 子路由path
 * @return {string}
 */
export const joinPath = (path, subPath) => (subPath
    ? subPath.startsWith('/') ? subPath : (path + (path.endsWith('/') ? '' : '/') + subPath)
    : path);


/**
 * 判断url是否是绝对路径
 *
 * @param {string} url 路径
 * @return {boolean}
 */
export const isAbsolutePath = url => {
    // 绝对路径以 http 或 https 开头
    const absolutePathReg = /^(http:\/\/|https:\/\/|baijia:\/\/|lingxi-internal:\/\/).*/;
    return absolutePathReg.test(url);
};
